/* from shao yh
   return true=>条件不满足
*/
import i18n from '@/i18n'

const check = {
  //错误的弹窗
  error: function (msg) {
    this.$message.closeAll();
    this.$message({
      message: msg,
      offset: 62,
      type: 'warning'
    });
  },
  //成功的弹窗
  success: function (msg) {
    this.$message.closeAll();
    this.$message({
      message: msg,
      offset: 62,
      type: 'success'
    });
  },
  //验证不能为空
  isEmpty: function (opt) {
    return !opt.toString().trim();
  },
  //验证数字
  isNumber(opt) {
    //判断是否为空
    let reg = /^\d+\.?\d*$/;
    return !reg.test(opt);
  },
  checkAge(rule, value, callback) {
    if (!value) {
      return callback(new Error('年龄不能为空'));
    }
    setTimeout(() => {
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (value < 18) {
          callback(new Error('必须年满18岁'));
        } else {
          callback();
        }
      }
    }, 1000);
  },
  isNum(rule, value, callback) {
    if (!value) {
      callback()
    }
    let reg = /^\d+\.?\d*$/;
    if (!reg.test(value)) {
      return callback(new Error("格式不正确"));
    } else {
      callback()
    }
  },
  //身份证验证
  isCard(rule, value, callback) {
    let reg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
    if (value == '') {
      return callback(new Error("身份证号码不能为空"));
    } else if (!reg.test(value)) {
      return callback(new Error("格式不正确"));
    } else {
      callback()
    }
  },
  isNumberAndLetter(rule, value, callback) {
    if (!value) {
      callback()
    }
    let reg = /^[A-Za-z0-9]{1,30}$/;
    if (!reg.test(value)) {
      return callback(new Error("格式不正确"));
    } else {
      callback()
    }
  },
  isPhone(rule, value, callback) {
    if (!value) {
      callback()
    }
    // let reg=/^1[3456789]\d{9}$/;
    //let reg=/(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}|^1[3456789]\d{9}$/;
    // let fixedTel = /^[((\+\d+)*)(\d+\-)*]*\s*\d+$/;
    if (value.trim().length === 0) {
      return callback(new Error("格式不正确"));
    } else {
      callback()
    }
    /*if (!reg.test(value)) {
      return callback(new Error("格式不正确"));
    }else{
      callback()
    } */
  },
  isEmails(rule, value, callback) {
    if (!value) {
      callback()
    }
    // let reg=/^\w+@\w+(\.\w+)+$/;
    let reg = /^[\w\-\.]+@\w+[\-\_\.\w]+$/;
    if (!reg.test(value)) {
      return callback(new Error(i18n.t("user_Index_EMAILGS")));
    } else {
      callback()
    }
    // console.log('isEmails',rule, value);

    // if(value.trim() == ''){
    //     return callback(new Error("邮箱格式不正确"));
    // } else{
    //   callback()
    // }
  },
  //手机号
  isTel: function (opt) {
    // let reg=/^1[3456789]\d{9}$/; 
    // let reg=/(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}|^1[3456789]\d{9}$/;
    /*  let reg = /^[\d+\+?\s?]$/; */
    /* return !reg.test(opt); 
        true =>false 
        false =>true  true=> tijian bu manzu 
    */
    return opt.trim().length === 0;
  },
  //连接超时
  netWork: function () {
    this.$message.closeAll();
    this.$message({
      message: '连接超时，请刷新重试!',
      type: 'warning'
    });
  },
  //验证邮箱
  isEmail(opt) {
    //true=>条件 不满足
    return opt.trim().length === 0;
  },
  /** 图片压缩，默认同比例压缩
  *  @param {Object} fileObj
  *  图片对象
  *  回调函数有一个参数，base64的字符串数据
  */
  compress(fileObj, callback) {
    try {
      const image = new Image()
      image.src = URL.createObjectURL(fileObj)
      image.onload = function () {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = fileObj.width || w
        h = fileObj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
          quality = fileObj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const data = canvas.toDataURL('image/jpeg', quality)
        // 压缩完成执行回调
        const newFile = convertBase64UrlToBlob(data)
        callback(newFile)
      }
    } catch (e) {
      console.log('压缩失败!')
    }
  },
  convertBase64UrlToBlob(urlData) {
    const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
    // 处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i)
    }
    return new Blob([ab], { type: 'image/png' })
  }
};
export default check;